module.exports = __webpack_public_path__ + "img/sb.5bbe7672.svg";